const FANCYBOX_CSS_URL = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.css';
const FANCYBOX_JS_URL = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.umd.js';

/**
 *
 * @param {IntersectionObserverEntry[]} entries
 * @param {IntersectionObserver} observer
 */
function handleIntersection( entries, observer ) {

	entries.forEach( ( entry ) => {

		if ( entry.isIntersecting ) {

			const imageBlock = entry.target.querySelector( '.b-image-text .wp-block-image img' );
			const imageWrapper = entry.target.querySelector( '.b-image-text .wp-block-image' );
			if ( ! imageBlock || ! imageWrapper ) {

				observer.unobserve( entry.target );
				return;

			}
			imageWrapper.classList.add( 'wp-block-image--loaded' );
			imageBlock.style.transform = 'scale(1)';
			observer.unobserve( entry.target );

		}

	} );

}

/**
 *
 */
function setupIntersectionObserver() {

	if ( window.innerWidth > 768 ) {

		document.querySelectorAll( '.b-image-text' ).forEach( ( block ) => {

			const observer = new IntersectionObserver( handleIntersection, {
				threshold: 0.5,
			} );

			observer.observe( block );

		} );

	}

}

/**
 *
 * @param url
 */
function getVimeoEmbedUrl( url ) {

	if ( ! url ) {

		return '';

	}

	const match = url.match( /vimeo\.com\/(?:video\/)?(\d+)/ );
	if ( ! match || ! match[ 1 ] ) {

		return '';

	}

	const videoId = match[ 1 ];
	return `https://player.vimeo.com/video/${ videoId }?autoplay=1&title=0&byline=0&portrait=0`;

}

/**
 *
 * @param mobileValue
 * @param desktopValue
 */
function getResponsiveValue( mobileValue, desktopValue ) {

	if ( window.innerWidth > 768 ) {

		return desktopValue || mobileValue || '';

	}

	return mobileValue || desktopValue || '';

}

/**
 *
 * @param href
 */
function ensureStylesheet( href ) {

	if ( document.querySelector( `link[href="${ href }"]` ) ) {

		return;

	}

	const link = document.createElement( 'link' );
	link.rel = 'stylesheet';
	link.href = href;
	document.head.appendChild( link );

}

/**
 *
 */
function ensureFancyboxAvailable() {

	return new Promise( ( resolve, reject ) => {

		if ( window.Fancybox ) {

			resolve();
			return;

		}

		ensureStylesheet( FANCYBOX_CSS_URL );

		const existingScript = document.querySelector( `script[src="${ FANCYBOX_JS_URL }"]` );
		if ( existingScript ) {

			if ( existingScript.dataset.loaded === 'true' ) {

				resolve();
				return;

			}

			existingScript.addEventListener( 'load', () => resolve() );
			existingScript.addEventListener( 'error', () => reject( new Error( 'Fancybox failed to load' ) ) );
			return;

		}

		const script = document.createElement( 'script' );
		script.src = FANCYBOX_JS_URL;
		script.async = true;
		script.onload = () => {

			script.dataset.loaded = 'true';
			resolve();

		};
		script.onerror = () => reject( new Error( 'Fancybox failed to load' ) );
		document.head.appendChild( script );

	} );

}

/**
 *
 */
function initializeFirstImageVimeoLightboxes() {

	const firstImageWrappers = [];

	document.querySelectorAll( '.b-image-text' ).forEach( ( block, blockIndex ) => {

		const firstImage = block.querySelector( '.b-image-text-single--image' );
		if ( ! firstImage ) {

			return;

		}

		const trigger = firstImage.querySelector( '.b-image-text-single__video-trigger' );
		if ( ! trigger ) {

			return;

		}

		const desktopUrl = trigger.dataset.videoDesktopUrl || '';
		const mobileUrl = trigger.dataset.videoMobileUrl || '';
		const selectedUrl = getResponsiveValue( mobileUrl, desktopUrl );
		const embedUrl = getVimeoEmbedUrl( selectedUrl );
		const hasVideoSource = !! embedUrl;

		firstImage.classList.toggle( 'b-image-text-single--image-video', hasVideoSource );

		if ( ! hasVideoSource ) {

			trigger.removeAttribute( 'href' );
			trigger.removeAttribute( 'data-fancybox' );
			trigger.removeAttribute( 'data-type' );
			return;

		}

		trigger.setAttribute( 'href', embedUrl );
		trigger.setAttribute( 'data-fancybox', `image-text-video-${ blockIndex }` );
		trigger.setAttribute( 'data-type', 'iframe' );
		firstImageWrappers.push( firstImage );

	} );

	if ( firstImageWrappers.length === 0 ) {

		return;

	}

	ensureFancyboxAvailable().then( () => {

		if ( window.Fancybox ) {

			window.Fancybox.bind( '[data-fancybox^="image-text-video-"]', {} );

		}

	} ).catch( ( error ) => {

		void error;

	} );

}

setupIntersectionObserver();
initializeFirstImageVimeoLightboxes();
window.addEventListener( 'resize', () => {

	setupIntersectionObserver();
	initializeFirstImageVimeoLightboxes();

} );
